import { loadScript } from './loadScript'
import cpSite from './cpSite'
import config from './config'
import { waitModuleReady } from './waitModuleReady'

/**
 * Кнопка загрузки актуальной версии Chromium-GOST
 */
let init = false

const chromiumGostDownload = {
  depend: ['vue', 'element-ui'],
  state: {
    lib: config.DEVMODE ? ['js/chromiumGost/vue.template.js'] : [config.THEME + 'js/chromiumGost/vue.template.js'],
    isActive: false,
    el: undefined
  },
  activate: function () {
    // Не проводить повторную инициализацию
    if (init) {
      return
    }

    // Критерий дальнейшего запуска
    const gostButtonEl = document.querySelector('chromium-gost-download')
    // Если объекта нет, то ничего не делать
    if (!gostButtonEl) {
      if (config.DEVMODE) {
        console.log('chromiumGostDownload: no element')
      }
      return
    }
    this.state.el = gostButtonEl

    this.initialize(this)
    // Ожидание готовности новых скриптов
    waitModuleReady(() => (window.Vue && window.Vue.options.components?.ElButton), () => { this.embedVueObject() }, 30)
  },
  initialize () {
    cpSite.module.elementUi.activate() // Включение библиотеки Vue и ElementUI
    init = true
  },
  embedVueObject () {
    loadScript(this.state.lib[0]) // Запуск логики объекта Vue
    this.state.isActive = true// Инициализация
  }
}

export default chromiumGostDownload
